import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const taskCompletionBlockersStyleId = 'blocks-task-completion-blockers-theme';

export const taskCompletionBlockersBridgeStyles = {
  'task-completion-blockers': {
    '--local-task-blockers-bg': tokens.color.background.errorPrimary,
    '--local-task-blockers-border': tokens.componentColors.utility.error200,
    '--local-task-blockers-accent': tokens.componentColors.utility.error600,
    '--local-task-blockers-title-color': tokens.color.text.errorPrimary,
    '--local-task-blockers-radius': tokens.radius.md,
    '--local-task-blockers-padding': `${tokens.spacing.lg} ${tokens.spacing.xl}`,
    '--local-task-blockers-section-gap': tokens.spacing.lg,
    '--local-task-blockers-header-gap': tokens.spacing.md,
    '--local-task-blockers-text-gap': tokens.spacing.xxs,
    '--local-task-blockers-title-weight': tokens.font.weight.semibold,
    '--local-task-blockers-title-size': tokens.font.size.textSm,
    '--local-task-blockers-font-size': tokens.font.size.textSm,
    '--local-task-blockers-text-color': tokens.color.text.secondary,
    '--local-task-blockers-muted-color': tokens.color.text.tertiary,
    '--local-task-blockers-rows-bg': tokens.color.background.primary,
    '--local-task-blockers-rows-border': tokens.color.border.secondary,
    '--local-task-blockers-rows-radius': tokens.radius.sm,
    '--local-task-blockers-row-padding': `${tokens.spacing.md} ${tokens.spacing.lg}`,
    '--local-task-blockers-name-color': tokens.color.text.primary,
    '--local-task-blockers-name-weight': tokens.font.weight.medium,
    '--local-task-blockers-unchanged-weight': tokens.font.weight.regular,
    '--local-task-blockers-opt-in-padding': `${tokens.spacing.md} ${tokens.spacing.lg}`,
    '--local-task-blockers-opt-in-border': tokens.color.border.primary,
  },
  // Amber when the user may authorise completing anyway; red when they are stopped.
  'task-completion-blockers.overridable': {
    '--local-task-blockers-bg': tokens.color.background.warningPrimary,
    '--local-task-blockers-border': tokens.componentColors.utility.warning200,
    '--local-task-blockers-accent': tokens.componentColors.utility.warning600,
    '--local-task-blockers-title-color': tokens.color.text.warningPrimary,
  },
};
